module.exports = __webpack_public_path__ + "static/media/phone.7122c85e.png";